import {
  Input as UiInput,
  InputNumber as UiInputNumber,
} from "@rumbledirect/ui";
import { QuestionTextModel } from "survey-core";

const NumberInput = (props: { question: QuestionTextModel }) => {
  const { question } = props;

  return (
    <UiInputNumber
      style={{ width: "100%", fontWeight: 500 }}
      styles={{
        input: {
          height: "var(--ant-control-height, 48px)",
          padding: "0 16px",
          boxSizing: "border-box",
        },
      }}
      id={question.inputId}
      disabled={question.isDisabledAttr || question.isReadOnlyAttr}
      readOnly={question.isReadOnlyAttr}
      value={question.inputValue}
      min={question.renderedMin}
      max={question.renderedMax}
      step={question.renderedStep}
      precision={0}
      inputMode="numeric"
      onBlur={(e) => question.onBlur(e)}
      onFocus={(e) => question.onFocus(e)}
      onChange={(value) => {
        question.value = value;
      }}
      placeholder={props.question.locPlaceholder.getLocaleText("")}
      onKeyUp={question.onKeyUp}
      onKeyDown={question.onKeyDown}
      aria-required={question.a11y_input_ariaRequired}
      aria-label={question.a11y_input_ariaLabel}
      aria-labelledby={question.a11y_input_ariaLabelledBy}
      aria-describedby={question.a11y_input_ariaDescribedBy}
      aria-invalid={question.a11y_input_ariaInvalid}
      aria-errormessage={question.a11y_input_ariaErrormessage}
    />
  );
};

const TextInput = (props: { question: QuestionTextModel }) => {
  const { question } = props;

  return (
    <UiInput
      styles={{
        root: { fontWeight: 500 },
        input: {
          height: "var(--ant-control-height, 48px)",
          padding: "0 16px",
          boxSizing: "border-box",
        },
      }}
      id={question.inputId}
      disabled={question.isDisabledAttr || question.isReadOnlyAttr}
      readOnly={question.isReadOnlyAttr}
      value={question.inputValue}
      type={question.inputType}
      style={question.inputStyle}
      maxLength={question.getMaxLength()}
      min={question.renderedMin}
      max={question.renderedMax}
      step={question.renderedStep}
      list={question.dataListId}
      autoComplete={question.autocomplete}
      autoCapitalize={question.autoCapitalize}
      placeholder={props.question.locPlaceholder.getLocaleText("")}
      onBlur={(e) => question.onBlur(e)}
      onFocus={(e) => question.onFocus(e)}
      onChange={(e) => question.onChange(e)}
      onClick={question.readOnlyBlocker}
      onPointerDown={question.readOnlyBlocker}
      onKeyUp={question.onKeyUp}
      onKeyDown={question.onKeyDown}
      onCompositionUpdate={(event) =>
        question.onCompositionUpdate(event.nativeEvent)
      }
      aria-required={question.a11y_input_ariaRequired}
      aria-label={question.a11y_input_ariaLabel}
      aria-labelledby={question.a11y_input_ariaLabelledBy}
      aria-describedby={question.a11y_input_ariaDescribedBy}
      aria-invalid={question.a11y_input_ariaInvalid}
      aria-errormessage={question.a11y_input_ariaErrormessage}
    />
  );
};

export const InputQuestion = (props: { question: QuestionTextModel }) => {
  if (props.question.inputType === "number") {
    return <NumberInput question={props.question} />;
  }

  return <TextInput question={props.question} />;
};
